import { Observable } from '@reactivex/rxjs';
import hoistStatics from 'react-recompose/hoistStatics';
import mapPropsStream from 'react-recompose/mapPropsStream';

import { getAdjacentBin } from './components/chart.tsx';

export const withPlay = hoistStatics(
    mapPropsStream(propsStream => {
        const propsObs = Observable.from(propsStream)
            .publish()
            .refCount();

        propsObs
            .switchMap(
                props => props?.timebar?.mode && props?.timebar?.play
                    ? Observable.interval(props?.timebar?.speed ? 1 / props?.timebar?.speed * 1000 : 1000)
                    : Observable.empty(),
                props => props
            )
            .map(({ onUpdateTimebarPlayheadStart, details, timebar }) =>
                onUpdateTimebarPlayheadStart({
                    value: getAdjacentBin({ timebar, details })
                }))
            .subscribe();

        return propsObs;
    })
);

